export default {
  cloud_name: "dkz9kcsqy",
  upload_preset: "quickStreet"
};
